export default "__VITE_ASSET__T2fJdEw9__"